import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { ArrowLeft } from 'lucide-react'
import type { FlashcardGameSession } from '@features/flashcards/state/flashcards-state'
import {
  LearningTemplateCompletionConfetti,
  LearningTemplateGameResult,
  LearningTemplateResultBar,
} from '@features/learning/shared/templates'
import './flashcard-game.css'

export function FlashcardGameResultScreen({
  onReturn,
  session,
}: {
  readonly onReturn: () => void
  readonly session: FlashcardGameSession
}) {
  const ui = useLearningUiTranslation()
  const total = session.prompts.length
  const accuracy = total === 0 ? 0 : Math.round((session.correctCount / total) * 100)

  return (
    <LearningTemplateGameResult
      actions={(
        <LearningTemplateResultBar
          embedded
          finished
          label="Return to flashcards"
          leadingIcon={<ArrowLeft aria-hidden="true" className="size-4" />}
          onNext={onReturn}
          size="lg"
          variant="primary"
        />
      )}
      description={ui("Round complete. Keep the momentum going with another set of cards.")}
      metrics={[
        { label: ui("Correct"), value: session.correctCount },
        { label: ui("Incorrect"), value: session.incorrectCount },
        { label: ui("Total prompts"), value: total },
      ]}
      title={ui("Flashcard game completed")}
    >
      <LearningTemplateCompletionConfetti />
      <div className="flashcardGameResultVisual">
        <div className="flashcardGameResultVisualCopy">
          <span className="flashcardGameResultVisualEyebrow">{ui("YOUR ROUND")}</span>
          <strong>{ui('{{percent}}% accuracy', { percent: accuracy })}</strong>
          <p>{ui('{{correct}} of {{total}} prompts answered correctly.', { correct: session.correctCount, total })}</p>
        </div>
        <img alt={ui("Learning complete")} src="/images/learning-done.webp" />
      </div>
    </LearningTemplateGameResult>
  )
}
